import { createAction, handleActions } from 'redux-actions';
// api
import api from '../../utils/api';

const initialState = {
  userSkills: null,
  defaultSkills: [],
  isLoading: false
};

// const
export const GET_USER_SKILLS = 'skills/GET_USER_SKILLS';
export const ADD_SKILL = 'skills/ADD_SKILL';
export const DELETE_SKILL = 'skills/DELETE_SKILL';
export const EDIT_SKILL = 'skills/EDIT_SKILL';
export const CHANGE_ORDER = 'skills/CHANGE_ORDER';

// action creators
export const getUserSkills = createAction(
  GET_USER_SKILLS,
  api.skills.getUserSkills
);
export const addSkill = createAction(ADD_SKILL, api.skills.addSkill);
export const deleteSkill = createAction(DELETE_SKILL, data => ({
  promise: api.skills.deleteSkill(data),
  data
}));
export const editSkill = createAction(EDIT_SKILL, api.skills.editSkill);
export const changeOrder = createAction(CHANGE_ORDER, data => ({
  promise: api.skills.changeOrder(data),
  data
}));

// reducer
const reducer = handleActions(
  {
    [`${GET_USER_SKILLS}_REQUEST`]: state => {
      return {
        ...state,
        isLoading: true
      };
    },

    [`${GET_USER_SKILLS}_ERROR`]: state => {
      return {
        ...state,
        isLoading: false
      };
    },

    [`${GET_USER_SKILLS}_SUCCESS`]: (state, action) => {
      const { resources, meta } = action.payload;
      return {
        ...state,
        defaultSkills: meta.default_skills,
        userSkills: resources,
        isLoading: false
      };
    },

    [`${ADD_SKILL}_SUCCESS`]: (state, { payload: { resource } }) => {
      const { userSkills } = state;
      return {
        ...state,
        userSkills: [...userSkills, resource]
      };
    },

    [`${EDIT_SKILL}_SUCCESS`]: (state, { payload: { resource } }) => {
      const userSkills = state.userSkills.map(
        skill => (resource.id === skill.id ? resource : skill)
      );
      return {
        ...state,
        userSkills
      };
    },

    [`${DELETE_SKILL}_REQUEST`]: (state, { payload: { id } }) => {
      const userSkills = state.userSkills.filter(skill => skill.id !== id);
      return {
        ...state,
        userSkills
      };
    },

    [`${CHANGE_ORDER}_REQUEST`]: (state, { payload: { skill_id_list } }) => {
      const userSkills = skill_id_list.map(id =>
        state.userSkills.find(skill => skill.id === id)
      );
      return {
        ...state,
        userSkills
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/skills.js